const config = require("config");

(function () {
  angular
    .module("app")
    .factory("favoriteNameValidator", [
      "$http",
      "$q",
      "customPlaceSetService",
      "favoriteLocationsService",
      "_",
      function (
        $http,
        $q,
        customPlaceSetService,
        favoriteLocationsService,
        _
      ) {
        // returns promise that resolves if unique and rejects if not unique
        //   tests against all custom places for the user/account, including favorites
        function isNameUnique(newName) {
          if (customPlaceSetService.isDataLoaded()) {
            return isCustomPlaceOrFavoriteNameUniqueToLocalData(newName);
          } else {
            return isCustomPlaceOrFavoriteNameUniqueToCloudData(newName);
          }
        }
        // returns promise that resolves if unique and rejects if not unique
        function isCustomPlaceOrFavoriteNameUniqueToLocalData(newName) {
          const deferred = $q.defer();
          customPlaceSetService.getCustomPlaceSets()
            .then(sets => {
              const customPlaceLocations = _.flatten(sets.map(set => set.Places));
              const isUniqueToCustomPlaceNames = customPlaceLocations
                .every(loc => angular.lowercase(loc.Name) !== angular.lowercase(newName));

              const isUniqueToFavoriteNames = favoriteLocationsService.getAllLocations()
                .every(loc => angular.lowercase(loc.Name) !== angular.lowercase(newName));

              if (isUniqueToCustomPlaceNames && isUniqueToFavoriteNames) {
                deferred.resolve(true);
              } else {
                deferred.reject();
              }
            });
          return deferred.promise;
        }

        // TODO pchen: write new back-end for this specific use case
        //   (to do everything in 1 call instead of 2)
        // returns promise that resolves if unique and rejects if not unique
        function isCustomPlaceOrFavoriteNameUniqueToCloudData(newName) {
          // pchen: compares to private custom places (includes personal favs)
          // TODO pchen: check if prod customers have private custom places outside of personal favs
          return checkPlaceNameMatchInDA(newName, {useShared: false})
            .then(() => {
              // pchen: nesting these for the small performance improvement where
              //   we don't need to check shared if we've already failed for private
              // pchen: compares to shared account-level custom places (includes shared favs)
              return checkPlaceNameMatchInDA(newName, {useShared: true});
            });
        }
        // checks if place name is already in user/account places
        //   should be called twice: 1. useShared = false and 2. useShared = true;
        //   useShared=false will come back with private custom
        //   places (including personal favs) useShared=true will
        //   come back with shared account-level custom places
        //   (including shared favs)
        // returns promise that resolves if unique and rejects if not unique
        function checkPlaceNameMatchInDA(newName, {useShared = true} = {}) {
          if (!newName) {
            return $q.reject();
          }

          const deferred = $q.defer();

          const params = {
            "includePlaces": true,
            // pchen: don't want other users' personal favs
            "onlyMine": true,
            "useShared": useShared,
            "readOnlyPublicData": false,
            // get only places whose names contain "name"
            //   (others are definitely unique to "name")
            "placeNameFilter": newName
          };

          const request = {
            method: "GET",
            url: `${config.daUrl}place-sets/-1`,
            params: params
          };

          $http(request)
            .then(({ data: placeSetList }) => {
              // expect placeSetList: [ { Places: [ { PlaceName } ] | null } ]
              const isUnique = placeSetList
                .filter(placeSet => placeSet && Array.isArray(placeSet.Places) && placeSet.Places.length > 0)
                .map(placeSet => placeSet.Places)
                // return true if every existing name is unique to "name" arg
                .every(placesList => {
                  return placesList.every(place => {
                    return place.PlaceName.toLowerCase() !== newName.toLowerCase();
                  });
                })
              if (isUnique) {
                deferred.resolve(true);
              } else {
                deferred.reject();
              }
            })
            .catch(err => {
              // pchen let the user save if the webservice isn't working as expected
              // TODO pchen: err handling - maybe show a warning?
              deferred.resolve(true);
            });

          return deferred.promise;
        }

        return {
          isNameUnique
        }
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/places/favoriteNameValidator.service.js